<template>
  <upPopup
    :show="show"
    @close="close"
    title="壹心理Cares全程保障"
    :showCloseBtn="true"
    :autoHeight="false"
    :buttons="buttons"
    :label="'我知道了'"
    class="qingsu-ensure-rule-model-box"
  >
    <div class="qingsu-ensure-rule-model">
      <div>
        <dl class="list" v-for="(item, index) in rules" :key="index">
          <dt class="title" v-if="item.title">
            <img
              :src="
                require(`../../../../images/platform/homepage/${item.icon}.png`)
              "
              alt=""
              v-if="item.icon"
              class="item-icon"
            />{{ item.title }}
          </dt>
          <dd
            :class="{ desc: true, 'desc-pb': index === 5 }"
            v-html="item.desc"
          ></dd>
        </dl>
      </div>
      <dl class="list">
        <dd class="desc desc-last">
          客服电话:400-788-9001（转接心理咨询业务）<br />
          客服时间:工作日10:00-19:00
        </dd>
      </dl>
    </div>
  </upPopup>
</template>

<script>
import upPopup from '../common/upPopup.vue'

export default {
  components: {
    upPopup
  },
  props: {
    rules: {
      type: Array,
      default() {
        return [
          {
            icon: 'lock',
            title: '隐私保护',
            desc:
              '充分尊重每位来访者的隐私，全方位保护你的个人信息，保证通话过程私密安全'
          },
          {
            icon: 'refund',
            title: '严格筛选',
            desc: '所有入驻倾听师均经过严格甄选，高于行业标准'
          },
          {
            icon: 'filter',
            title: '资质担保',
            desc:
              '通过严格的人工审查机制，承诺所有倾听师的受训经历均经过真实性检验'
          },
          {
            icon: 'data',
            title: '7天退款到账',
            desc: '与倾听师约定取消倾诉后，7天内自动退费到账'
          }
        ]
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [{ label: '我知道了' }]
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.qingsu-ensure-rule-model-box {
  /deep/ .common-model-up-btn {
    height: 86px;
    background: linear-gradient(180deg, #fecec6 0%, #fc7052 100%);
    border-radius: 48px;
    /deep/ .common-model-up-btn-label {
      font-size: 32px;
      font-weight: 600;
    }
  }
  /deep/ .common-model-up-close-btn {
    display: none;
  }
}
.qingsu-ensure-rule-model {
  padding: 20px 30px 43px;
  max-height: 800px;
  .list {
    padding-left: 46px;
    padding-bottom: 20px;
    .desc {
      font-size: 26px;
      color: #6c798c;
      line-height: 38px;
      margin-bottom: 50px;
    }
    .desc-pb {
      margin-bottom: 0;
    }
  }
  .title {
    display: flex;
    align-items: center;
    font-size: 32px;
    color: #21252d;
    line-height: 32px;
    position: relative;
    margin-bottom: 20px;
    font-weight: 500;
    .item-icon {
      width: 36px;
      height: 36px;
      position: absolute;
      right: 100%;
      margin-right: 13px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .close-btn {
    font-size: 26px;
    color: #ffffff;
    line-height: 28px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
    background: #ffa202;
  }
}
</style>
